import React, { useState, useContext } from 'react';
import styled, { keyframes } from 'styled-components';
import { EventDatetimeContext } from 'components/EventDatetime';
import BackgroundImage from 'assets/landing/background-618.jpg';
import Footer from 'components/Footer';
import ResetEmailModal from './ResetEmailModal';
import TopBar from '../../TopBar';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }

  55% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

const fadeInBottom = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(30px);
  }

  80% {
    opacity: 0;
    transform: translateX(-50%) translateY(30px);
  }

  100% {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
`;

const ButtonContainer = styled.div`
  width: ${() => window.innerWidth * 0.35}px;
  top: 50%;
  position: absolute;
  max-width: 400px;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  animation: ${fadeIn} 3s ease-in;
`;

const LoginButton = styled.button`
  min-height: 48px;
  margin: 0px auto;
  padding: 8px 32px;
  background: #2C6143;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
  letter-spacing: -0.408px;
  color: #FFFFFF;
  cursor: pointer;
  outline: none;
`;

const EventEndText = styled.div`
  font-weight: 500;
  top: 50%;
  font-size: 50px;
  line-height: 65px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  letter-spacing: -0.408px;
  color: #FFF;
  animation: ${fadeIn} 3s ease-in;
`;

const FooterContainer = styled.div`
  left: 50%;
  transform: translateX(-50%);
  animation: ${fadeInBottom} 3s ease-in;
  position: absolute;
  bottom: 0;
`;

const PageContentWrapper = styled.div`
  background-color: #3d9d91;
`;

const PageUpDownSplitter = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;

  & > :first-child {
    flex: 0 1 auto;
  }

  & > :last-child {
    flex: 1 1 auto;
  }
`;
const Landing618BG = styled.img`
  width: 100%;
  height: auto;
  position: relative;
`;

const LandingPage = () => {
  const [isResendEmailModalOpened, setIsResendEmailModalOpened] = useState(false);
  const {
    hasEventStarted,
    hasEventEnded,
  } = useContext(EventDatetimeContext);

  return (
    <PageUpDownSplitter>
      <TopBar />
      <ResetEmailModal
        open={isResendEmailModalOpened}
        handleClose={() => { setIsResendEmailModalOpened(false); }}
        onRegisterNowBtnClick={() => {
          setIsResendEmailModalOpened(false);
        }}
      />
      <PageContentWrapper>
        <Landing618BG src={BackgroundImage} alt="PolyU BG" id="landing-bg" />
        {hasEventStarted && (
          <ButtonContainer>
            <LoginButton onClick={() => { setIsResendEmailModalOpened(true); }}>
              Join Career Fair Now
            </LoginButton>
          </ButtonContainer>
        )}
        {hasEventEnded && (
          <EventEndText>
            Event Finished
            <br />
            See You Next Time
          </EventEndText>
        )}
        <FooterContainer>
          <Footer />
        </FooterContainer>
      </PageContentWrapper>
    </PageUpDownSplitter>
  );
};

export default LandingPage;
